"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var immutable_1 = require("immutable");
var mapValues_1 = require("../utils/mapValues");
var createProvider_1 = require("../provider/createProvider");
var getContext = function (key) {
    var context = react_1.useContext(createProvider_1.Context);
    return react_1.useMemo(function () { return context[key]; }, [context, key]);
};
var useImmutableState = function (initialValue) {
    var _a = react_1.useState(initialValue), state = _a[0], setState = _a[1];
    var updateState = function (next) { return Object.keys(state).find(function (k) { return !immutable_1.is(state[k], next[k]); }) && setState(next); };
    return react_1.useMemo(function () { return [state, updateState]; }, [state]);
};
var createHook = function (handlers, mapProps, field) { return function (key) {
    if (key === void 0) { key = 'default'; }
    var _a = getContext(key), agent = _a.agent, analytics = _a.analytics, config = _a.config;
    var getState = react_1.useCallback(function (changes, meta) {
        var _a;
        if (changes === void 0) { changes = field !== 'query' ? agent.response.getIn(field.split(':')) : agent.state; }
        if (meta === void 0) { meta = agent.response.get('meta') || immutable_1.Map(); }
        var mapped = mapProps && mapProps(changes, meta, agent.set, analytics, config);
        return __assign({ meta: meta }, (mapped || (_a = {}, _a[field] = changes, _a)));
    }, []);
    var _b = useImmutableState(getState()), state = _b[0], setState = _b[1];
    var _handlers = react_1.useMemo(function () {
        return mapValues_1.default(handlers, function (createHandler) { return createHandler(__assign({ analytics: analytics, update: agent.set }, state)); });
    }, [state]);
    react_1.useEffect(function () {
        var _updater = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return setState(getState.apply(void 0, args));
        };
        agent.on("change:" + field, _updater);
        window.requestAnimationFrame(function () { return _updater(); });
        return function () { return agent.off(_updater); };
    }, []);
    return react_1.useMemo(function () { return (__assign({}, state, _handlers, { update: agent.set, analytics: analytics, config: config })); }, [state]);
}; };
var useFeatureContext = function (key) {
    if (key === void 0) { key = 'default'; }
    var _a = getContext(key), agent = _a.agent, analytics = _a.analytics, config = _a.config;
    return ({ update: agent.set, analytics: analytics, config: config });
};
var createComponent = function (_a) {
    var BaseComponent = _a.BaseComponent, hook = _a.hook, key = _a.key;
    var factory = react_1.createFactory(BaseComponent);
    return function (props) {
        var data = hook(key);
        return factory(__assign({}, props, data));
    };
};
exports.default = (function (_a) {
    var field = _a.field, handlers = _a.handlers, mapProps = _a.mapProps;
    var hook = field === 'config' ? useFeatureContext : createHook(handlers, mapProps, field);
    return [
        hook,
        function (connector) {
            return typeof connector === 'function'
                ? createComponent({
                    hook: hook,
                    BaseComponent: connector
                })
                : function (BaseComponent) {
                    return createComponent(__assign({ BaseComponent: BaseComponent,
                        hook: hook }, connector));
                };
        }
    ];
});
//# sourceMappingURL=createConnect.js.map